// extracted by mini-css-extract-plugin
export default {"titleBar":"Accounts_titleBar__8dWUj","btnsContainer":"Accounts_btnsContainer__FWWdH","closeButton":"Accounts_closeButton__dJePK"};